import { ExclamationCircleFilled } from '@ant-design/icons';
import { Col, SpinProps, Table } from 'antd';
import { ColumnType } from 'antd/lib/table';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';

import { t } from '../../../i18n';
import { AssessmentSentTable } from '../../../pages/CandidateTests';
import { TestResultCollection } from '../../../types';
import Title from './Title';

interface TestStatusTableProps {
  loading?: boolean | SpinProps;
  tableRows?: AssessmentSentTable[];
  results?: TestResultCollection[];
}

const columns: ColumnType<AssessmentSentTable>[] = [
  {
    title: t('Testes'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: t('Data de envio'),
    dataIndex: 'sentAt',
    key: 'sentAt',
    render: (value) => (
      <>
        {value ? (
          moment(value).format('DD/MM/YYYY - HH:mm [GMT] Z')
        ) : (
          <>
            <ExclamationCircleFilled style={{ color: 'red' }} /> <Trans>Não enviado</Trans>
          </>
        )}
      </>
    ),
  },
  {
    title: 'Status',
    dataIndex: 'finished',
    key: 'finished',
    render: (value) => (
      <>
        {value ? (
          <>
            <ExclamationCircleFilled style={{ color: 'green' }} /> <Trans>Realizado</Trans>
          </>
        ) : (
          <>
            <Trans>Pendente</Trans>
          </>
        )}
      </>
    ),
  },
];

const TestStatusTable: React.FC<TestStatusTableProps> = ({ results, tableRows, loading }) => {
  const { t } = useTranslation();

  const addFinishedToRow = (row: AssessmentSentTable): AssessmentSentTable => {
    switch (row.type) {
      case 'OPERATIONAL':
        row.finished = !!Object.keys(
          results?.find((testResult) => testResult.type === 'OPERATIONAL')?.secondary_score || {}
        ).length;
        break;
      case 'INTERESTS':
        row.finished = !!Object.keys(
          results?.find((testResult) => testResult.type === 'INTERESTS')?.secondary_score || {}
        ).length;
        break;
      case 'MOTIVATIONAL':
        row.finished =
          typeof results?.find((testResult) => testResult.type === 'MOTIVATIONAL')
            ?.primary_score === 'number';
        break;
      case 'SJT':
        row.finished =
          typeof results?.find((testResult) => testResult.type === 'SJT')?.primary_score ===
          'number';
        break;
      case 'OCP':
        row.finished =
          typeof results?.find((testResult) => testResult.type === 'OCP')?.primary_score ===
          'number';
        break;
      case 'PROFILEMAP':
        row.finished = Array.isArray(
          results?.find((testResult) => testResult.type === 'PROFILEMAP')?.secondary_score
        );
        break;
      case 'LOGIC':
        row.finished =
          typeof results?.find((testResult) => testResult.type === 'LOGIC')?.primary_score ===
          'number';
        break;
    }
    return row;
  };

  return (
    <Col>
      <Title title={t('Status dos testes')} />
      <Table
        rowKey="type"
        pagination={false}
        loading={loading}
        dataSource={tableRows?.map(addFinishedToRow).sort((a, b) => {
          if (a.name < b.name) return -1;
          else return 1;
        })}
        columns={columns}
      />
    </Col>
  );
};

export default TestStatusTable;
